import { call, put, select } from 'redux-saga/effects';
import { setDomainUsers } from '../../../../state/analytic/analyticAdminSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchDomainUsersSaga(action) {
    const { domain } = yield select(selectUserCredentials);
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            `admin/domains/${encodeURIComponent(domain)}/users`
        );
        yield put(setDomainUsers(data || []));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to fetch domain users', err?.response?.status, err?.message);
    }
}